/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    IBusinessSignUpItem,
    IBusinessSignUpViewProps
} from '@msdyn365-commerce-modules/business-account-management/src/modules/business-sign-up';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IBusinessSignUpProps } from '../definition-extensions/business-sign-up.ext.props.autogenerated';

const BusinessSignUpItem: React.FC<IBusinessSignUpItem> = ({ wrapper, label, errorMessage, input, isAddressInput }) => {
    // hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isAddressInput && label}
            {!isAddressInput && errorMessage}
            {input}
        </Node>
    );
};

// function _renderSignUpToRecieveEmail(signupToReceiveEmail: string): React.ReactNode {
//     return (
//         <Node className='sign-up-item-signupToReceiveEmail'>
//             <input
//                 className='sign-up-item-signupToReceiveEmail-input'
//                 name='extension_SignupToReceiveEmail'
//                 id='SignupToReceiveEmail'
//                 type='checkbox'
//                 aria-checked='false'
//                 value='1'
//             />
//             <label className='sign-up-item-signupToReceiveEmail-label' id='signupToReceiveEmail_label' htmlFor='signupToReceiveEmail'>
//                 {' '}
//                 {signupToReceiveEmail}{' '}
//             </label>
//         </Node>
//     );
// }

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps & IBusinessSignUpProps<{}>> = props => {
    const { businessSignUp, ContainerWrapper, heading, businessSignUpForm } = props;
    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;
    const {phonePlaceholderID,phonePlaceholderText}=props.resources;
    React.useEffect(() => {
        document.getElementById(phonePlaceholderID)?.setAttribute('placeholder', phonePlaceholderText);
    },[]);
    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                {heading}
                <Node {...FormWrapper}>
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            return <BusinessSignUpItem key={item.id} {...item} />;
                        })}
                    {/* {_renderSignUpToRecieveEmail(signupToReceiveEmail)} */}
                    {errorMessage &&
                        errorMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                    {disclaimer}
                </Node>
            </Node>
        </Module>
    );
};

export default BusinesSignUpView;
